import { GET_BULK_WEIGHT_DISCREPANCY_COUNT_SUCCESS, GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST, GET_BULK_WEIGHT_DISCREPANCY_COUNT_FAILURE, GET_BULK_WEIGHT_DISCREPANCY_COUNT_RESET, } from "@/redux/actions";
const initialState = {
    Count: null,
    loading: false,
    error: null,
};
const getBulkWeightDiscrepancyCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BULK_WEIGHT_DISCREPANCY_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, Count: action.payload });
        case GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST:
            return Object.assign({}, state);
        case GET_BULK_WEIGHT_DISCREPANCY_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_BULK_WEIGHT_DISCREPANCY_COUNT_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, Count: null });
        default:
            return state;
    }
};
export default getBulkWeightDiscrepancyCountReducer;
